import { render, staticRenderFns } from "./gc-status-chip.vue?vue&type=template&id=1cd39128&scoped=true"
import script from "./gc-status-chip.vue?vue&type=script&lang=js"
export * from "./gc-status-chip.vue?vue&type=script&lang=js"
import style0 from "./gc-status-chip.vue?vue&type=style&index=0&id=1cd39128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd39128",
  null
  
)

export default component.exports